"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Defaults = Defaults;
/**
 * @param {{}} props
 */
function Defaults(props) {

    return function (target) {

        var proto = target.prototype;

        Object.keys(props).forEach(function (key) {
            if (!proto.hasOwnProperty(key)) {
                Object.defineProperty(proto, key, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: props[key]
                });
            }
        });
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9EZWZhdWx0cy5qcyJdLCJuYW1lcyI6WyJEZWZhdWx0cyIsInByb3BzIiwidGFyZ2V0IiwicHJvdG8iLCJwcm90b3R5cGUiLCJPYmplY3QiLCJrZXlzIiwiZm9yRWFjaCIsImhhc093blByb3BlcnR5Iiwia2V5IiwiZGVmaW5lUHJvcGVydHkiLCJlbnVtZXJhYmxlIiwiY29uZmlndXJhYmxlIiwid3JpdGFibGUiLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFHZ0JBLFEsR0FBQUEsUTtBQUhoQjs7O0FBR08sU0FBU0EsUUFBVCxDQUFrQkMsS0FBbEIsRUFBeUI7O0FBRTVCLFdBQU8sVUFBVUMsTUFBVixFQUFrQjs7QUFFckIsWUFBSUMsUUFBUUQsT0FBT0UsU0FBbkI7O0FBRUFDLGVBQU9DLElBQVAsQ0FBWUwsS0FBWixFQUFtQk0sT0FBbkIsQ0FBMkIsZUFBTztBQUM5QixnQkFBSSxDQUFDSixNQUFNSyxjQUFOLENBQXFCQyxHQUFyQixDQUFMLEVBQWdDO0FBQzVCSix1QkFBT0ssY0FBUCxDQUFzQlAsS0FBdEIsRUFBNkJNLEdBQTdCLEVBQWtDO0FBQzlCRSxnQ0FBWSxJQURrQjtBQUU5QkMsa0NBQWMsSUFGZ0I7QUFHOUJDLDhCQUFVLElBSG9CO0FBSTlCQywyQkFBT2IsTUFBTVEsR0FBTjtBQUp1QixpQkFBbEM7QUFNSDtBQUNKLFNBVEQ7QUFXSCxLQWZEO0FBaUJIIiwiZmlsZSI6IkRlZmF1bHRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAcGFyYW0ge3t9fSBwcm9wc1xuICovXG5leHBvcnQgZnVuY3Rpb24gRGVmYXVsdHMocHJvcHMpIHtcblxuICAgIHJldHVybiBmdW5jdGlvbiAodGFyZ2V0KSB7XG5cbiAgICAgICAgbGV0IHByb3RvID0gdGFyZ2V0LnByb3RvdHlwZTtcblxuICAgICAgICBPYmplY3Qua2V5cyhwcm9wcykuZm9yRWFjaChrZXkgPT4ge1xuICAgICAgICAgICAgaWYgKCFwcm90by5oYXNPd25Qcm9wZXJ0eShrZXkpKSB7XG4gICAgICAgICAgICAgICAgT2JqZWN0LmRlZmluZVByb3BlcnR5KHByb3RvLCBrZXksIHtcbiAgICAgICAgICAgICAgICAgICAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgY29uZmlndXJhYmxlOiB0cnVlLFxuICAgICAgICAgICAgICAgICAgICB3cml0YWJsZTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgdmFsdWU6IHByb3BzW2tleV1cbiAgICAgICAgICAgICAgICB9KVxuICAgICAgICAgICAgfVxuICAgICAgICB9KTtcblxuICAgIH1cblxufVxuIl19